import { Query, Route } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

export enum STEPS {
    PROVIDERS = 'providers',
    SIGN_IN = 'sign-in',
    RENEW_PASSWORD = 'renew-password',
    CHECK_EMAILS = 'check-emails',
    RESET_PASSWORD = 'reset-password',
    INTERNAL_LOGIN = 'internal-login',
    SEND_EMAIL = 'authenticated-magic-links',
    CHECK_EMAILS_MAGIC_LINK = 'check-emails-magic-link',
    CHECK_EMAILS_TWO_FACTOR = 'check-emails-two-factor',
}

export interface SignInRouteParams {
    step?: STEPS;
}

const signInRoute: Route = {
    path: '/:step*',
    appId: AppId.login,
};

const signIn = ({ step }: SignInRouteParams, query?: Query): Route => ({
    ...signInRoute,
    params: {
        step,
    },
    query,
});

export { signIn, signInRoute };
